import { navPageDefault, navPagesFRMAdmin, navPagesTenantAdmin, pages } from './constants';

import { availableRoles, User } from '@senderra/shared/features/user-management/api/types';

export const getPagesByRole = (permissions: User['roleName'][]) => {
if (permissions.includes(availableRoles[0])) {
        return navPagesTenantAdmin;
    } else if (permissions.includes(availableRoles[1])) {
        return navPagesFRMAdmin;
    } else {
        return navPageDefault;
    }
};

export const getRoutesByRole = (permissions: User['roleName'][]) => {
    let userPages: (typeof pages)[keyof typeof pages] = pages.default;

    if (permissions.includes(availableRoles[0])) {
        userPages = pages.tenant;
    } else if (permissions.includes(availableRoles[1])) {
        userPages = pages.frm;
    }

    return Object.values(userPages);
};
